<div *ngFor="let parent of parents; let i = index" class="form-fields-span">
    <!-- Parent Dropdown -->
    <mat-form-field class="col-5">
        <mat-label>{{ parentTypeName }}</mat-label>
        <input
            matInput
            type="text"
            placeholder="Pick one"
            [matAutocomplete]="parentAutocomplete"
            [formControl]="parent.formGroup.get('parent_title')"
            (input)="onParentInputChange($event, i)"
            [matTooltip]="tooltipText"
            matTooltipPosition="right"
            matTooltipClass="right"
        />
        <mat-autocomplete
            #parentAutocomplete="matAutocomplete"
            (optionSelected)="onParentSelected($event, i)"
            requireSelection="true"
            [displayWith]="displayParentOptions"
        >
            <mat-option *ngFor="let option of filteredParentChoices" [value]="option">
                {{ option.parent_title }}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="parent.formGroup.get('parent_title').hasError('required')">
            {{ parentTypeName }} is required
        </mat-error>
    </mat-form-field>

    <!-- Parent Inputs -->
    <div class="col-4" *ngIf="parent.formGroup.contains('inputs')">
        <div class="parent-input" *ngFor="let input of parent.inputs; let j = index">
            <div class="w-100" *ngIf="input.input_type !== 'boolean'">
                <div *ngIf="input.options" [class]="'autocomplete-container' + (j > 0 ? ' input-not-first' : '')">
                    <div>
                        <!-- <div class="mat-mdc-text-field-wrapper mdc-text-field ng-tns-c508571215-200 mdc-text-field--filled mdc-text-field--no-label mdc-text-field--invalid">
                            <div class="mat-mdc-form-field-flex"> -->
                        <!-- <input
                                                    matInput
                                                    type="text"
                                                    placeholder="Pick one"
                                                    [(ngModel)]="parent.formGroup.get('inputs').get(input.input_name)"
                                                    (input)="onParentInputValueChange($event, i, input.input_name)"
                                                    [matTooltip]="getToolTip(input)"
                                                    matTooltipPosition="right"
                                                    matTooltipClass="right"
                                                /> -->
                        <p-autoComplete
                            appendTo="body"
                            [multiple]="input.multiple"
                            [inputStyleClass]="
                                'mat-mdc-input-element mat-mdc-tooltip-trigger mat-mdc-form-field-input-control mdc-text-field__input cdk-text-field-autofill-monitored' +
                                (input.multiple ? ' input-multiple' : ' input-single')
                            "
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="38"
                            [virtualScrollOptions]="input.options === 'sizes' ? { lazy: true } : {}"
                            requireSelection
                            showClear
                            dropdown
                            fluid
                            dropdownMode="current"
                            [type]="input.input_type"
                            [placeholder]="getToolTip(input)"
                            (optionSelected)="onParentInputSelected($event, i, input.input_name)"
                            (completeMethod)="onParentMultiselectInputValueChanged($event, i, input.input_name)"
                            (onLazyLoad)="input.options === 'sizes' && onSizesLazyLoad($event, i, input.input_name)"
                            [formControl]="parent.formGroup.get('inputs').get(input.input_name)"
                            [suggestions]="filteredParentInputOptions[i + '-' + input.input_name]"
                            (onClear)="onClearMultiselect($event, parent, input)"
                            (onFocus)="focusBlurInput($event, input.multiple, true)"
                            (onBlur)="focusBlurInput($event, input.multiple, false)"
                        >
                            <!-- <mat-option
                                            *ngFor="let option2 of "
                                            [value]="option2"
                                        >
                                            {{ option2 }}
                                        </mat-option> -->
                        </p-autoComplete>
                        <!-- </div>
                        </div> -->
                    </div>
                </div>
                <mat-form-field class="w-100" *ngIf="!input.options">
                    <div *ngIf="input.input_type === 'pct'">
                        <input
                            matInput
                            type="number"
                            placeholder="Enter a percentage"
                            [formControl]="parent.formGroup.get('inputs').get(input.input_name)"
                            [matTooltip]="getToolTip(input)"
                            matTooltipPosition="right"
                            matTooltipClass="right"
                        />
                    </div>
                    <div *ngIf="input.input_type !== 'pct'">
                        <input
                            matInput
                            type="text"
                            placeholder="Enter a value"
                            [formControl]="parent.formGroup.get('inputs').get(input.input_name)"
                            [matTooltip]="getToolTip(input)"
                            matTooltipPosition="right"
                            matTooltipClass="right"
                        />
                    </div>
                    <!-- <div *ngIf="input.data_query === 'products'">
                        <mat-chip-grid #productChipGrid aria-label="Enter products" 
                            [formControl]="parent.formGroup.get('inputs').get(input.input_name)">
                            @for (product_id of input.chips(); track product_id) {
                            <mat-chip-row (removed)="removeProductId(input, product_id)">
                                {{product_id}}
                            <button matChipRemove [attr.aria-label]="'remove template form' + keyword">
                                <mat-icon>cancel</mat-icon>
                            </button>
                            </mat-chip-row>
                        }
                        </mat-chip-grid>
                        <input
                            matInput
                            type="text"
                            placeholder="Enter products"
                            [matChipInputFor]="productChipGrid"
                            (matChipInputTokenEnd)="addProductId($event, input)"
                            [matTooltip]="getToolTip(input)"
                            matTooltipPosition="right"
                            matTooltipClass="right"
                        />
                    </div> -->
                </mat-form-field>
                <!-- <mat-form-field class="w-100">
                    <input matInput style="opacity:0" /> -->
                <mat-error *ngIf="parent.formGroup.get('inputs').get(input.input_name).hasError('required')">
                    {{ input.input_name }} is required
                </mat-error>
                <mat-error *ngIf="parent.formGroup.get('inputs').get(input.input_name).hasError('invalidInteger')"
                    >Value must be a positive integer
                </mat-error>
                <mat-error *ngIf="parent.formGroup.get('inputs').get(input.input_name).hasError('invalidFloat')"
                    >Value must be a positive number
                </mat-error>
                <mat-error *ngIf="parent.formGroup.get('inputs').get(input.input_name).hasError('badProducts')"
                    >Value must be an existing product
                </mat-error>
                <!-- </mat-form-field> -->
            </div>
            <div
                *ngIf="input.input_type === 'boolean'"
                [style]="parentTypeName === 'Condition' || !input.input_name ? 'display:none' : ''"
            >
                <mat-label>{{ input.input_name }}</mat-label>
                <mat-checkbox [formControl]="parent.formGroup.get('inputs').get(input.input_name)" />
            </div>
        </div>
    </div>

    <!-- Remove Parent Button -->
    <button type="button" mat-button class="col-1" color="warn" (click)="removeParent(i)">Remove</button>
</div>
<button type="button" mat-button class="add-another" color="accent" (click)="addParent()">
    Add Another {{ parentTypeName }}
</button>
